// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"44bb05b0","147":"4e4592b8","367":"86b0a157","376":"5c058fcf","483":"32225c1b","488":"83fbfb27","528":"644fdc95","591":"aea3e18a","636":"cc65243c","769":"4b703ff2","813":"4e57ae17","960":"c5a32eb9"}[chunkId] + ".chunk.js";
};